import styled from 'styled-components';
import { rem } from 'polished';

export const Section = styled.section`
  padding: ${rem('40px')} ${rem('20px')};
  overflow-x: hidden;

  /* Add global keyframes for the logo animation */
  @keyframes logoFloat {
    0%,
    100% {
      transform: translateY(0px) scale(1);
    }
    25% {
      transform: translateY(-8px) scale(1.02);
    }
    50% {
      transform: translateY(0px) scale(1.05);
    }
    75% {
      transform: translateY(-4px) scale(1.02);
    }
  }

  @keyframes accentPulse {
    0%,
    100% {
      opacity: 0.7;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.1);
    }
  }
`;

export const Content = styled.div`
  display: grid;
  place-items: center;
  gap: ${rem('25px')};
  grid-template-columns: 1fr 1fr;
  width: 100%;
  max-width: 100%;

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    grid-template-columns: 1fr;
    padding: 0 ${rem('8px')};

    & img {
      grid-row: 2/3;
    }
  }
`;

export const Item = styled.div`
  align-self: flex-start;
  width: 100%;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;

  p {
    @media ${({ theme }) => theme.mediaQueries.smallMax} {
      padding: 0 ${rem('8px')};
    }
  }

  h1 {
    font-family: 'MontserratBlack', sans-serif;
    color: #1f2937;
    font-size: ${({ theme }) => theme.variables.fontSizeH1};
    line-height: 1.3;
    letter-spacing: -0.5px;
    font-weight: 800;
    margin-bottom: 1.5rem;

    @media ${({ theme }) => theme.mediaQueries.smallMax} {
      text-align: center;
      font-size: clamp(2rem, 4vw, 3rem);
    }

    @media ${({ theme }) => theme.mediaQueries.mediumMax} {
      font-size: clamp(2.2rem, 4vw, 3.5rem);
    }
  }
`;

export const SectionImg = styled.img`
  justify-self: right;
  max-height: ${rem('300px')};
  margin: 0 auto;
  object-fit: cover;
`;
